import PropTypes from 'prop-types';
import React from 'react';
import styled, { css } from 'styled-components';
import { formatPrice } from '@codex-brightworld/helpers';

import { Bold } from '../TextStyles';

const Wrapper = styled.div`
  ${({
    theme
  }) => css`
    overflow: hidden;
    padding: 5px;
    border-top: 1px solid ${theme.colors.shades[5]};
    border-bottom: 1px solid ${theme.colors.shades[5]};
    text-align: center;
    text-overflow: ellipsis;
    font-size: 14px;
  `}
`;

/**
 * @tags styled, price
 */
function PriceBlock(props) {
  const priceDisplay = typeof props.price === 'string'
    ? formatPrice(props.price, true, props.currency)
    : formatPrice(props.price, false, props.currency);

  return (
    <Wrapper {...props} data-qa={props.qa}>
      {props.title &&
        <Bold>{props.title}{' '}</Bold>}
      <Bold>{priceDisplay}</Bold>
      {props.info &&
        <span>{' '}{props.info}</span>}
    </Wrapper>
  );
}

PriceBlock.propTypes = {
  currency: PropTypes.string,
  info: PropTypes.string,
  price: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  title: PropTypes.string,
  qa: PropTypes.string
};

PriceBlock.defaultProps = {
  currency: 'GBP',
  info: '',
  title: '',
  qa: undefined
};

PriceBlock.displayName = 'PriceBlock';

export default PriceBlock;
